import { gql } from '@apollo/client';

const CREATE_EMPLOYMENT = gql`
	mutation addEmployment($crewId: ID!, $input: CrewMemberEmploymentTypeInput!) {
		addEmploymentType(crewMemberId: $crewId, input: $input) {
			... on CrewMemberEmploymentTypeSuccessResponse {
				employmentType {
					id
				}
			}
			... on CrewMemberEmploymentTypeErrorResponse {
				errors
			}
		}
	}
`;

export default CREATE_EMPLOYMENT;
